import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { DevelopmentModule } from '@content-platform/web-angular-shared-util-development';

import { AuthModule } from '@content-platform/web-angular-shared-util-auth';
import { MsGraphApiModule } from '@content-platform/web-angular-administration-shared-data-access-ms-graph-api';
import { DebugFlagsDialogComponent } from './debug-flags-dialog/debug-flags-dialog.component';
import { DebugFlagsDialogService } from './services/debug-flags-dialog.service';
import { NgPipesModule } from 'ngx-pipes';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatListModule,
    MatButtonModule,
    MatInputModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatIconModule,
    AuthModule,
    MsGraphApiModule,
    DevelopmentModule,
    NgPipesModule
  ],
  providers: [DebugFlagsDialogService],
  declarations: [DebugFlagsDialogComponent],
  entryComponents: [DebugFlagsDialogComponent]
})
export class ReusableUiFeatureFlagsModule {}
